<template>
  <el-form
      ref="form"
      :model="form"
      :inline="true"
      :disabled="disabled"
      hide-required-asterisk>
    <!-- <div class="title">分时调整竞价</div> -->

    <div>
      <gj-alert type="warning" show-icon>
        <template #title>
          <div>以上三种分时规则不需都填写，分时执行时仅执行已填写的规则；</div>
          <div>当应用对象为广告活动时，适用三种分时规则，当应用对象为广告组或投放时，仅适用“调整竞价”规则。</div>
        </template>
      </gj-alert>
    </div>

    <gj-table
        :index="false"
        name="adjustBidStrategyForm"
        :data="form.items"
        :columns="columns"
        :adapt-height="false"
        :height="405"
        style="margin: 12px 0;"
        :show-overflow="false">
      <template v-slot:header:strategy>
        竞价
        <gj-help popperClass="gj-tooltip--500" class="gj-help">
            竞价增加%：计算出的调整值和最多增加值对比，大于最多增加值，使用原始竞价+最多增加值作为竞价目标值，小于最多增加值，使用原始竞价+计算出的调整值作为竞价目标值。如竞价增加50%，最多增加$1，原始竞价为$3，3*0.5=1.5>1，则竞价调整为$4=3+1，最多增加值为$2，1.5&lt;2，则竞价调整为$4.5=3+3*0.5。
            <br />
            竞价降低%：最低调整至，表示调价规则计算出的目标竞价不能低于最低调整值，低于则使用最低调整值作为目标竞价。如竞价降低50%，最低调整至$1，原始竞价为$3，3*（1-0.5）=1.5>1，则竞价调整为$1.5，如原始竞价为$1.8，1.8*（1-0.5）=0.9&lt;1，则竞价调整为$1。
        </gj-help>
      </template>
      <template v-slot:triggerType="{ index }">
        <el-form-item
            :prop="`items.${index}.triggerType`"
            :rules="[
              { required: true, message: '请选择触发类型', trigger: ['change'] },
            ]"
            class="gj-table-item">
          <gj-select
              v-model="form.items[index].triggerType"
              :options="AdStrategyEnum.triggerTypeOption"
              :clearable="false"
              :size="size">
          </gj-select>
        </el-form-item>
      </template>

      <template v-slot:repeat="{ index }">
        <el-form-item
            :prop="`items.${index}.repeat`"
            :rules="[
              { required: needValid, message: '请选择重复周期', trigger: ['change'] },
            ]"
            class="gj-table-item">
          <gj-select
              v-model="form.items[index].repeat"
              :options="form.items[index].repeatOption"
              multiple
              width="280px"
              :clearable="false"
              :size="size"
              @input="repeatInput(form.items[index], form.items[index].repeatOption)">
          </gj-select>
        </el-form-item>
      </template>

      <template v-slot:time="{ index }">
        <el-form-item
            :prop="`items.${index}.startTime`"
            :rules="[
              { required: needValid, message: '请选择开始时间', trigger: ['change'] },
            ]"
            class="gj-table-item"
            style="margin-right: 10px;">
          <gj-time-select
              v-model="form.items[index].startTime"
              :picker-options="{
                ...AdStrategyEnum.timeOption,
                maxTime: form.items[index].endTime
              }"
              placeholder="开始时间"
              :clearable="false"
              :size="size"
          ></gj-time-select>
        </el-form-item>
        <el-form-item
            :prop="`items.${index}.endTime`"
            :rules="[
              { required: needValid, message: '请选择结束时间', trigger: ['change'] },
            ]"
            class="gj-table-item">
          <gj-time-select
              v-model="form.items[index].endTime"
              :picker-options="{
                ...AdStrategyEnum.timeOption,
                minTime: form.items[index].startTime
              }"
              :clearable="false"
              placeholder="结束时间"
              :size="size"
          ></gj-time-select>
        </el-form-item>
      </template>

      <template v-slot:strategy="{ index }">
        <el-form-item
            :prop="`items.${index}.adjustType`"
            :rules="[
              { required: true, message: '请选择调整类型', trigger: ['change'] },
            ]"
            class="gj-table-item"
            style="margin-right: 10px;">
          <gj-select
              v-model="form.items[index].adjustType"
              :options="AdStrategyEnum.adjustForm.adjustTypeOption"
              :clearable="false"
              :filterable="false"
              placeholder="请选择"
              :size="size"
              width="110px"
          ></gj-select>
        </el-form-item>
        <el-form-item
            v-if="form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD
              || form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB"
            :prop="`items.${index}.adjustPercent`"
            :rules="[
              { required: needValid, message: '请输入百分比', trigger: ['change'] },
              needValid ? $gjReRule(RE.pt0, '请输入正整数') : {required: false}
            ]"
            class="gj-table-item"
            style="margin-right: 10px;">
          <gj-input
              v-model="form.items[index].adjustPercent"
              placeholder="请输入"
              :size="size"
              width="73px"
              :clearable="false">
            <!--            <template #append>%</template>-->
          </gj-input>
        </el-form-item>
        <el-form-item
            v-if="form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.VALUE_ADD
              || form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.VALUE_SUB
              || form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.VALUE_FIXED"
            :prop="`items.${index}.adjustValue`"
            :rules="[
              { required: needValid, message: '请输入数值', trigger: ['change'] },
              needValid ? $gjReRule(RE.num(2), '最多两位小数的正数') : {required: false}
            ]"
            class="gj-table-item"
            style="margin-right: 10px;">
          <gj-input
              v-model="form.items[index].adjustValue"
              placeholder="请输入"
              :size="size"
              width="110px">
          </gj-input>
        </el-form-item>
        <el-form-item
            v-if="form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD
              || form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB"
            :prop="`items.${index}.limit`"
            :rules="[ $gjReRule(RE.num(2), '最多两位小数的正数') ]"
            class="gj-table-item"
            style="margin-right: 10px;">
          <template #label>
            <template v-if="form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB">
              最低调整到
            </template>
            <template v-if="form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD">
              最多调整
            </template>
          </template>
          <gj-input
              v-model="form.items[index].limit"
              placeholder="选填"
              :size="size"
              width="110px">
          </gj-input>
        </el-form-item>
      </template>

      <template v-slot:op="{ index, row }">
        <gj-button
            type="iconfont"
            iconfont="iconzengjia"
            size="20px"
            :disabled="form.globalSet"
            @click="addItem(index, row)"
            >
        </gj-button>
        <gj-button
            type="iconfont"
            iconfont="iconjianshao"
            size="20px"
            v-if="form.items.length > 1"
            :disabled="form.globalSet"
            @click="deleteItem(index)"
            >
        </gj-button>
      </template>
    </gj-table>

    <div>
      <gj-alert type="info" show-icon>
        <template #title>
          <div>分时调整可调整关键词竞价，根据设定的对象进行调整。设定广告活动、广告组时，将对广告活动、广告组的所有关键词竞价进行调整；</div>
          <div>使用分时调价过程中，如果手动修改竞价或在亚马逊后台修改竞价，分时调价会以最后手动修改的竞价为原竞价。不在调整时间范围内，系统自动恢复原价。</div>
        </template>
      </gj-alert>
    </div>
  </el-form>
</template>

<script>
  import {formDeleteItemMixin, formRuleMixin} from "../../../../../../../../minxins";
  import {AdStrategyEnum} from "../../../../common/enum";
  import {isMeaningful, isMeaningless} from "../../../../../../../../utils/common";

  export default {
    name: "app-adjust-bid-strategy-form",
    mixins: [formDeleteItemMixin, formRuleMixin],
    props: {
      form: {
        required: true
      },
      disabled: {
        type: Boolean,
        required: true
      },
      initForm$: {
        required: true
      }
    },
    data() {
      return {
        columns: [
          {id: 'triggerType', header: '触发类型', field: 'slot:triggerType', width: '120px'},
          {id: 'repeat', header: '重复周期', field: 'slot:repeat', minWidth: '280px'},
          {id: 'time', header: '站点时间', field: 'slot:time', width: '260px'},
          {id: 'strategy', header: 'slot:strategy', field: 'slot:strategy', minWidth: '450px'},
          {id: 'op', header: '操作', field: 'slot:op', width: '90px', notCustomColumn: true},
        ],
        size: 'default',
        AdStrategyEnum: AdStrategyEnum,
      }
    },
    watch: {
      initForm$: {
        handler: function (init) {
          if (isMeaningful(init) || isMeaningless(this.form.items) || this.form.items.length === 0) {
            this.form.items = [];
            this.addItem();
          }
        },
        immediate: true
      },
      'form.items': {
        handler: function(items) {
          if (isMeaningful(items)) {
            items.forEach(item => {
              this.repeatInput(item, item.repeatOption);
            });
          }
        },
        immediate: true,
      }
    },
    computed: {
      initState() {
        if (isMeaningless(this.form.items) || this.form.items.length === 0) {
          return true;
        }
        if (this.form.items.length === 1) {
          const item = this.form.items[0];
          return (isMeaningless(item.repeat) || item.repeat.length === 0)
              && isMeaningless(item.startTime)
              && isMeaningless(item.endTime)
              && (((item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD || item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB) && isMeaningless(item.adjustPercent) && isMeaningless(item.limit))
                  || ((item.adjustType === AdStrategyEnum.adjustForm.adjustType.VALUE_ADD || item.adjustType === AdStrategyEnum.adjustForm.adjustType.VALUE_SUB || item.adjustType === AdStrategyEnum.adjustForm.adjustType.VALUE_FIXED || item.adjustType ==='')
                      && isMeaningless(item.adjustValue)))
        }
        return false
      },
      needValid() {
        return !this.initState;
      }
    },
    methods: {
      addItem(index = -1, row = null) {
        this.form.items.splice(index + 1, 0, {
          triggerType: row ? row.triggerType : AdStrategyEnum.triggerType.time,
          adjustType: row ? row.adjustType : '',
          adjustValue: row ? row.adjustValue : null,
          adjustPercent: row ? row.adjustPercent : null,
          repeat: row ? row.repeat : [],
          repeatOption: AdStrategyEnum.repeatOption.map(item => ({
            ...item
          })),
          limit: row ? row.limit : null,
          startTime: row ? row.endTime : null,
          endTime: null
        });
      },
      repeatInput(item, repeatOption) {
        if (item.repeat && item.repeat.includes(0)) {
          // 包含每天，禁用周一至周日
          item.repeat = [0];
          repeatOption.forEach(option => {
            if (option.id !== 0) {
              option.disabled = true;
            }
          });
        } else {
          repeatOption.forEach(option => {
            option.disabled = false;
          });
        }
      },
      formValidate() {
        if (this.needValid) {
          return this.$gjFormValidate();
        }
        return true;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "common";
  /deep/.gj-table--default td:not(.vxe-footer--column) {
    &.vxe-body--column {
        height: 58px !important;
      }
  }
  /deep/ .el-input__suffix{
    color: #666666;
  }
  .gj-help {
    cursor: pointer;
  }
</style>
